import React, { useEffect, useRef } from "react";

const WHEPPlayer = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = document.getElementById("video")
        video.setAttribute('src', `http://42.96.43.172:30092/feb00dc117ba4c82bd48413242e2882121c00bcd9363b106078be872ae5e3300/live/whep`);
       
    }, []);

    return <whep-video width={10000} id="video" muted autoplay></whep-video>;
};

export default WHEPPlayer;
